// export const ga4Event = (eventName, params = {}) => {
//   if (typeof window !== "undefined" && window.gtag) {
//     window.gtag("event", eventName, params);
//   }
// };

export const ga4Event = async (eventName, params = {}) => {
  // try {
  //   // 1. Measurement ID GA4 (G-XXXXXXX)
  //   const measurementId = "G-6HG0LZS042";

  //   // 2. API Secret (buat di GA4 → Admin → Data Streams → Measurement Protocol API)
  //   const apiSecret = "yP4j8GnXSJe0EQJ9Xd6jRg";

  //   // 3. Client ID (GA4 wajib punya)
  //   // let clientId = localStorage.getItem("ga_client_id");
  //   // if (!clientId) {
  //   //   clientId = Math.random().toString(36).substring(2);
  //   //   localStorage.setItem("ga_client_id", clientId);
  //   // }
  //   let clientId = getGaClientIdFromCookie();

  //   // 4. Build event payload
  //   const payload = {
  //     client_id: clientId,
  //     events: [
  //       {
  //         name: eventName,
  //         params: params,
  //       },
  //     ],
  //   };

  //   // 5. Send to GA4 without GTM interference
  //   await fetch(
  //     `https://www.google-analytics.com/mp/collect?measurement_id=${measurementId}&api_secret=${apiSecret}`,
  //     {
  //       method: "POST",
  //       body: JSON.stringify(payload),
  //     }
  //   );
  // } catch (error) {
  //   console.error("GA4 direct event error:", error);
  // }
};

const getGaCookie = () => {
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("_ga="));

  return cookie ? cookie.split("=")[1] : null;
};

const getGaClientIdFromCookie = () => {
  const gaCookie = getGaCookie();
  if (!gaCookie) return null;

  const parts = gaCookie.split(".");
  if (parts.length < 4) return null;

  // Combine last 2 parts → client_id
  return `${parts[2]}.${parts[3]}`;
};